var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "gongde-box-pay-success-container" },
    [
      _c("van-nav-bar", {
        staticClass: "gongde-box-pay-success-nav-bar",
        attrs: { title: "功德箱", "left-arrow": "" },
        on: { "click-left": _vm.handleBack },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("van-icon", {
                  attrs: { name: "arrow-left", size: "18", color: "#333" },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("div", { staticClass: "gongde-box-pay-success-content" }, [
        _c("img", {
          staticClass: "cover",
          attrs: {
            src: "https://hk-public.tengzhihh.com/image/0340d12e241c3556154f06b98bf2e6f0-135x135.png",
            alt: "",
          },
        }),
        _vm.gongde
          ? _c("div", { staticClass: "gongde-box-pay-success-title" }, [
              _vm._v("感恩布施"),
            ])
          : _vm._e(),
        _c("div", { staticClass: "gongde-box-pay-success-gongde" }, [
          _vm._v(" 功德值 "),
          _c("span", { staticClass: "gongde-box-pay-success-gongde-value" }, [
            _vm._v("+" + _vm._s(_vm.gongde)),
          ]),
        ]),
        _vm.gongde
          ? _c("div", { staticClass: "gongde-box-pay-success-tips" }, [
              _vm._v("您的善心已送达，愿吉祥安康"),
            ])
          : _vm._e(),
        _c("div", { staticClass: "gongde-box-pay-success-explore" }, [
          _vm._v("探索更多"),
        ]),
        _c("div", { staticClass: "gongde-box-pay-success-explore-item" }, [
          _c("img", {
            attrs: {
              src: "https://hk-public.tengzhihh.com/image/02b65d7dc9932c7fbbab2fb2602a1deb-60x60.png",
              alt: "",
            },
          }),
          _c(
            "div",
            { staticClass: "gongde-box-pay-success-explore-item-title" },
            [_vm._v("再填善款，种植莲因")]
          ),
          _c(
            "div",
            {
              staticClass: "gongde-box-pay-success-explore-item-button",
              on: { click: _vm.handleExplore },
            },
            [_vm._v("去布施")]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }